import React from 'react';
import { Link } from 'react-router-dom';
import SEO from './SEO';
import Footer from './Footer';

const hardwoodFloorStyle = {
  background: `
    repeating-linear-gradient(90deg, #3d2817 0px, #4a3423 2px, #5c4033 4px, #4a3423 6px, #3d2817 8px),
    repeating-linear-gradient(0deg, transparent 0px, transparent 60px, rgba(0,0,0,0.15) 60px, rgba(0,0,0,0.15) 62px),
    linear-gradient(180deg, #4a3423 0%, #3d2817 50%, #2d1f12 100%)
  `,
  backgroundBlendMode: "overlay, overlay, normal"
};

export default function ContentPage({ title, description, path, jsonLd, children }) {
  return (
    <>
      <SEO title={title} description={description} path={path} jsonLd={jsonLd} />
      <div style={{
        ...hardwoodFloorStyle,
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '40px 20px 60px'
      }}>
        <div style={{
          maxWidth: 800,
          width: '100%',
          color: '#c9d1d9',
          fontFamily: "'Georgia', serif",
          lineHeight: 1.8,
          fontSize: 17
        }}>
          <Link to="/" style={{ textDecoration: 'none', display: 'inline-block', marginBottom: 24 }}>
            <img src="/BuckEuchreLogoWhite.png" alt="Euchre Table" style={{ height: 60 }} />
          </Link>

          <h1 style={{ color: '#fff', fontSize: 32, marginBottom: 24, lineHeight: 1.3 }}>{title}</h1>

          {children}

          {/* CTA Buttons */}
          <div style={{ display: 'flex', gap: 16, marginTop: 48, flexWrap: 'wrap' }}>
            <Link to="/play?mode=free" style={{
              background: 'linear-gradient(135deg, #1e1b4b, #312e81)',
              border: '2px solid #6366f1',
              borderRadius: 12,
              padding: '16px 32px',
              color: '#fff',
              textDecoration: 'none',
              fontWeight: 700,
              fontSize: 18,
              fontFamily: "'Georgia', serif"
            }}>
              Play Free Now
            </Link>
            <Link to="/signin" style={{
              background: 'linear-gradient(135deg, #1c3d2a, #1a2f1a)',
              border: '2px solid #3fb950',
              borderRadius: 12,
              padding: '16px 32px',
              color: '#fff',
              textDecoration: 'none',
              fontWeight: 700,
              fontSize: 18,
              fontFamily: "'Georgia', serif"
            }}>
              Create Free Account
            </Link>
          </div>

          {/* Internal Links Footer */}
          <nav style={{
            marginTop: 48,
            paddingTop: 24,
            borderTop: '1px solid rgba(255,255,255,0.15)'
          }}>
            <div style={{ color: '#8b949e', fontSize: 14, marginBottom: 12 }}>Learn More</div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px 24px' }}>
              <Link to="/buck-euchre-rules" style={{ color: '#58a6ff', fontSize: 15 }}>Buck Euchre Rules</Link>
              <Link to="/buck-euchre-strategy" style={{ color: '#58a6ff', fontSize: 15 }}>Buck Euchre Strategy</Link>
              <Link to="/euchre-rules" style={{ color: '#58a6ff', fontSize: 15 }}>Euchre Rules</Link>
              <Link to="/euchre-strategy" style={{ color: '#58a6ff', fontSize: 15 }}>Euchre Strategy</Link>
              <Link to="/euchre-variations" style={{ color: '#58a6ff', fontSize: 15 }}>Euchre Variations</Link>
              <Link to="/tutorial" style={{ color: '#58a6ff', fontSize: 15 }}>Interactive Tutorial</Link>
              <Link to="/about" style={{ color: '#58a6ff', fontSize: 15 }}>About</Link>
              <Link to="/leaderboards" style={{ color: '#58a6ff', fontSize: 15 }}>Leaderboards</Link>
              <Link to="/fairness" style={{ color: '#58a6ff', fontSize: 15 }}>Fairness</Link>
            </div>
          </nav>
          <Footer isMobile={false} />
        </div>
      </div>
    </>
  );
}
